import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/SmyMapAddress.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "add-address"
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('group', [_c(__unplugin_components_0, {
    attrs: {
      "defaultAddress": _vm.map_name,
      "defaultLatLong": [_vm.longitude, _vm.latitude],
      "defaultCode": _vm.defaultCode,
      "type": _vm.address_type
    },
    on: {
      "on-change": _vm.selectAddress
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: 120 + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(i18n.tc("242"))])])], 1), _c('group', [_c('x-input', {
    attrs: {
      "title": i18n.tc("244"),
      "placeholder": i18n.tc("239")
    },
    model: {
      value: _vm.detail_addr,
      callback: function ($$v) {
        _vm.detail_addr = $$v;
      },
      expression: "detail_addr"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: 120 + 'px'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(i18n.tc("244"))])])], 1), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.addAddress.apply(null, arguments);
      }
    }
  }, [_vm._v(i18n.tc("12"))])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };